import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      hero: { title: 'Web Developer & Designer' },
      expertise: {
        title: 'My Expertise',
        webDev: 'Image for web development expertise',
        uxui: 'Image for UX/UI design expertise',
        graphic: 'Image for graphic design expertise',
        multimedia: 'Image for multimedia editing expertise',
      },
      projects: { title: 'Projects' },
      commissions: {
        title: 'Client Projects',
        subtitle: '(Commissioned Works)',
      },
      footer: {
        discover: 'Discover more of my works!',
        github: 'Peek at my code on GitHub!',
        behance: 'See my design magic at Behance!',
      },
      browse: {
        previous: 'Previous Project',
        next: 'Next Project',
      },
      backToHomepage: 'Back to Homepage',
      demo: {
        seeHowBuilt: "See How It's Built",
        launchSite: 'Launch Site',
      },
      pageNotFound: {
        imageAlt: 'Image for page not found',
        title: 'Are you lost?',
        description: 'The page you are looking for does not exist.',
      },
      tiled: {
        viewCode: 'View Code',
        viewCodes: 'View Codes',
        view: 'View',
      },
      jigsawInventory: {
        description:
          'An inventory system currently being used by the Jigsaw Puzzle Community PH (JPCPH) and Puzzle Mansion administrators, to track thousands of jigsaw puzzles, in an effort to take back the Guinness World Record for having the most number of jigsaw puzzles in a collection.',
      },
      payroll: {
        description:
          'A comprehensive web application designed to streamline workforce operations across multiple branches. This system centralizes employee records, and automates payroll calculations, ensuring accuracy and efficiency in managing diverse staff roles. Built with scalability in mind, it empowers business owners to oversee branch performance while reducing administrative workload.',
      },
      petDex: {
        alert:
          'This project is a work in progress. The showcase displays only wireframes, intended to illustrate design direction rather than a final release.',
      },
      pixelate: {
        alert:
          '<strong>Heads up!</strong> Pixelate is actively evolving \u2014 new features and improvements are being added regularly.',
      },
      youtubeVideo: {
        alert:
          '<strong>Heads up!</strong> YouTube Music Player is actively evolving \u2014 new features and improvements are being added regularly.',
      },
      websites: {
        cardText:
          "Some quick example text to build on the card title and make up the bulk of the card's content.",
      },
    },
  },
  ja: {
    translation: {
      hero: { title: 'ウェブデベロッパー & デザイナー' },
      expertise: {
        title: '専門分野',
        webDev: 'ウェブ開発の専門知識の画像',
        uxui: 'UX/UIデザインの専門知識の画像',
        graphic: 'グラフィックデザインの専門知識の画像',
        multimedia: 'マルチメディア編集の専門知識の画像',
      },
      projects: { title: 'プロジェクト' },
      commissions: {
        title: 'クライアントプロジェクト',
        subtitle: '（受注作品）',
      },
      footer: {
        discover: '私の作品をもっと見る！',
        github: 'GitHubでコードを覗いてみよう！',
        behance: 'Behanceでデザインを見てみよう！',
      },
      browse: {
        previous: '前のプロジェクト',
        next: '次のプロジェクト',
      },
      backToHomepage: 'ホームページに戻る',
      demo: {
        seeHowBuilt: '作り方を見る',
        launchSite: 'サイトを開く',
      },
      pageNotFound: {
        imageAlt: 'ページが見つからない画像',
        title: '迷子ですか？',
        description: 'お探しのページは存在しません。',
      },
      tiled: {
        viewCode: 'コードを見る',
        viewCodes: 'コード一覧',
        view: '表示',
      },
      jigsawInventory: {
        description:
          'ジグソーパズルコミュニティPH（JPCPH）とパズルマンションの管理者が現在使用している在庫管理システム。数千のジグソーパズルを追跡し、コレクション内のジグソーパズルの最多数としてギネス世界記録を取り戻す取り組みの一環です。',
      },
      payroll: {
        description:
          '複数の支店にわたる業務運営を効率化するために設計された包括的なウェブアプリケーション。このシステムは従業員記録を一元管理し、給与計算を自動化して、多様なスタッフ業務の管理における正確性と効率性を確保します。スケーラビリティを考慮して構築されており、ビジネスオーナーが管理業務を削減しながら各支店のパフォーマンスを監督できるようにします。',
      },
      petDex: {
        alert:
          'このプロジェクトは開発中です。ショーケースにはワイヤーフレームのみが表示されており、最終リリースではなくデザインの方向性を示すことを目的としています。',
      },
      pixelate: {
        alert:
          '<strong>お知らせ：</strong> Pixelateは現在も進化を続けており、新しい機能と改良が定期的に追加されています。',
      },
      youtubeVideo: {
        alert:
          '<strong>お知らせ：</strong> YouTube Music Playerは現在も進化を続けており、新しい機能と改良が定期的に追加されています。',
      },
      websites: {
        cardText:
          'カードのタイトルに基づいて構築され、カードの内容の大部分を構成する簡単なテキスト例です。',
      },
    },
  },
};

const savedLanguage = localStorage.getItem('language') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

(i18n as any).on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng;
  localStorage.setItem('language', lng);
});

export default i18n;
